import { Link } from "react-router-dom";
import { Instagram, Facebook, Mail, Phone } from "lucide-react";
import { brand } from "../data/mock";

export default function Footer() {
  return (
    <footer className="bg-[hsl(var(--ink))] text-[hsl(var(--bg))] mt-24">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 py-20 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-4 font-editorial">
            <img
              src="https://customer-assets-39nsmqrw.emergentagent.net/job_elegant-event-design-1/artifacts/v1a0y2ji_Shobhawithshubhra-logo-final.png"
              alt="Shobha with Shubhra logo"
              className="h-20 md:h-24 w-auto object-contain"
            />
            <div>
              <div className="text-[10px] tracking-[0.5em] uppercase opacity-70">Shobha with</div>
              <div className="text-4xl md:text-5xl tracking-wider">Shubhra</div>
            </div>
          </div>
          <p className="mt-6 font-display text-xl md:text-2xl leading-snug max-w-md text-[hsl(var(--bg))]/85">
            Curating emotions through elegant weddings, immersive events and heirloom-worthy celebrations.
          </p>
          <div className="mt-8 flex items-center gap-5">
            <a href={brand.instagram} target="_blank" rel="noreferrer" className="hover:opacity-70"><Instagram size={18} /></a>
            <a href={brand.facebook} target="_blank" rel="noreferrer" className="hover:opacity-70"><Facebook size={18} /></a>
          </div>
        </div>

        <div>
          <div className="kicker text-[hsl(var(--bg))]/60">Explore</div>
          <ul className="mt-5 space-y-3 text-sm">
            <li><Link to="/about" className="hover:text-[hsl(var(--accent-soft))]">About</Link></li>
            <li><Link to="/weddings" className="hover:text-[hsl(var(--accent-soft))]">Weddings</Link></li>
            <li><Link to="/events" className="hover:text-[hsl(var(--accent-soft))]">Events</Link></li>
            <li><Link to="/portfolio" className="hover:text-[hsl(var(--accent-soft))]">Portfolio</Link></li>
            <li><Link to="/contact" className="hover:text-[hsl(var(--accent-soft))]">Contact</Link></li>
          </ul>
        </div>

        <div>
          <div className="kicker text-[hsl(var(--bg))]/60">Contact</div>
          <ul className="mt-5 space-y-3 text-sm">
            <li className="flex items-center gap-2"><Mail size={14} /><a href={`mailto:${brand.email}`} className="hover:text-[hsl(var(--accent-soft))]">{brand.email}</a></li>
            <li className="flex items-center gap-2"><Phone size={14} /><a href={`tel:${brand.phone}`} className="hover:text-[hsl(var(--accent-soft))]">{brand.phone}</a></li>
            <li className="opacity-70">{brand.location}</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="mx-auto max-w-[1400px] px-6 md:px-10 py-6 flex flex-col md:flex-row justify-between items-center gap-3 text-xs tracking-[0.2em] uppercase opacity-60">
          <span>© {new Date().getFullYear()} Shobha with Shubhra LLC</span>
          <div className="flex items-center gap-6">
            <Link to="/privacy" className="hover:opacity-100 hover:text-[hsl(var(--accent-soft))]">Privacy</Link>
            <Link to="/cookie-policy" className="hover:opacity-100 hover:text-[hsl(var(--accent-soft))]">Cookies</Link>
            <Link to="/terms" className="hover:opacity-100 hover:text-[hsl(var(--accent-soft))]">Terms</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
